// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-disabled[data-v-1ee226ea]::before{\n    content: \"\\f05e\";\n    position: absolute;\n    color: red;\n    z-index: 1;\n    font-size: 14px;\n}\n.nav-link[data-v-1ee226ea]{\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
